import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { getBaseUrl } from "../utils";
import { Link } from 'react-router-dom';

const Footer = () => {

    const [footerData, setFooterData] = useState(null);

    useEffect(() => {
        // Fetching data from the API
        axios
            .get(getBaseUrl() + 'user_api/setting')
            .then((response) => {
                if (response.data && response.data.results) {
                    setFooterData(response.data.results);
                }
            })
            .catch((error) => {
                console.error('Error fetching footer data:', error);
            });
    }, []);

    return (
        <div className='overflow-hidden'>
            <section className="footer_section pt-[50px]">
                <div className="container-xxl">
                    <div className="row flex items-center justify-center">
                        <div className="col-md-3 sm:pl-0 pl-4">
                            <div>
                                <img src="/assates/Logo____new.jpg" className="w-[300px]" />
                            </div>                      </div>
                        <div className="col-md-2 flex sm:items-center items-start justify-start sm:justify-center">
                            <div className="flex items-start sm:justify-center justify-start flex-col">
                                <h4 className="Header__text font-[700]" style={{ fontSize: '24px' }}> Quick Links</h4>
                                <ul className="Paragraph__etxt  font-[400 pt-2 flex flex-col gap-2">
                                    <Link to="/"><li>Home</li></Link>
                                    <Link to="/AboutUs"><li>About Us</li></Link>
                                    <Link to="/Blog"><li>Blog</li></Link>
                                    <Link to="/PrivacyPolicy"><li>Privacy Policy</li></Link>
                                    <Link to="/TermsAndConditions"><li>Terms & Conditions</li></Link>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md-4 flex sm:items-center items-start sm:justify-center justify-start">
                            <div className="flex items-start justify-center flex-col sm:pl-12 pl-0 sm:mt-0 mt-10">
                                <h4 className="Header__text font-[700]" style={{ fontSize: '24px' }}> Contact Us</h4>
                                <ul className="Paragraph__etxt  font-[400 pt-3 flex flex-col gap-2">

                                    <li className="flex gap-2 ]"><i class="ri-mail-fill"></i> {footerData?.contact_gmail || ''}</li>
                                    <li><i class="ri-phone-fill"></i> {footerData?.contact_number || ''}</li>
                                    {/* <li><i class="ri-user-location-fill"></i> {footerData?.contact_address || ''}</li> */}
                                    <li><i class="ri-user-location-fill"></i> Head Office, Plot No.<br></br> 111, Noida <br></br>Sector 136</li>



                                </ul>
                            </div>
                        </div>

                        <div className="col-md-3 flex sm:items-center items-start sm:justify-center justify-start md:pr-0">
                            <div className="flex sm:items-center  items-start mt-8 sm:mt-0 justify-center flex-col w-full">
                                <h4 className="Header__text font-[700]" style={{ fontSize: '24px' }}>Download App</h4>
                                <div className='w-full flex items-center gap-3 md:flex-col md:gap-1'>
                                    <a target='_blank' rel='noopener noreferrer' className="w-full" href='https://play.google.com/store/apps/details?id=com.mrguru.in&hl=en_IN'>
                                        <img src="/assates/playstore.svg" alt="Get MrGuru on Google Play" className="w-full " />
                                    </a>
                                    <a target='_blank' rel='noopener noreferrer' className="w-full" href='https://apps.apple.com/in/app/mrguru/id6748067680'>
                                        <img src="/assates/appstore.svg" alt="Download MrGuru on the App Store" className="w-full mt-1" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Footer;